import { Component, OnInit, ViewChild } from "@angular/core";
import { AuthServerProvider } from "../shared/auth/auth.service";
import {
    FormGroup,
    FormBuilder,
    Validators
} from "@angular/forms";
import { StateService } from "@uirouter/angular";
import { ErrorStateMatcher } from "@angular/material";
import { PasswordOperations } from "./password-operations.component";
import { ConfirmPasswordErrorStateMatcher } from "./confirm-password-error-state-matcher";
import { confirmPasswordMatchValidator } from "./confirm-password-match-validator";

@Component({
    template: require('./change-password.component.html')
})
export class ChangePassword implements OnInit {
    constructor(
        private authServerProvider: AuthServerProvider,
        private fb: FormBuilder,
        private stateService: StateService) { }

    changePasswordForm: FormGroup;

    confirmPasswordErrorStateMatcher: ErrorStateMatcher = new ConfirmPasswordErrorStateMatcher();

    get OldPassword() { return this.changePasswordForm.get("OldPassword"); }

    get NewPassword() { return this.changePasswordForm.get("NewPassword"); }

    get ConfirmPassword() { return this.changePasswordForm.get("ConfirmPassword"); }

    @ViewChild(PasswordOperations) passwordOperations: PasswordOperations;

    ngOnInit(): void {
        this.changePasswordForm = this.fb.group(
            {
                OldPassword: ['', Validators.required],
                NewPassword: ['', Validators.required],
                ConfirmPassword: ['', Validators.required]
            },
            {
                validator: confirmPasswordMatchValidator("NewPassword", "ConfirmPassword")
            });
    }

    onSubmit(): void {
        this.passwordOperations.performAction(
            () => this.authServerProvider.changePassword(this.changePasswordForm.value),
            "Password has been changed",
            "Could not save new password");
    }

    cancel(): void {
        this.stateService.go("app.home");
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/password/change-password.component.ts